//https://easings.net/

const easings = {
    easeOutCubic: "cubic-bezier(0.33, 1, 0.68, 1)",
    easeOutQuint: "cubic-bezier(0.22, 1, 0.36, 1)",
    easeInOutQuint: "cubic-bezier(0.83, 0, 0.17, 1)",
    easeOutCustom: "cubic-bezier(0.19, 1, 0.22, 1)",
} as const;

export type EasingType = typeof easings;

export default easings;
